const handleRedirect = (payload, propagateHash = false) => {
  const hash = propagateHash && (window.location?.hash || '');
  window.location = `${payload.redirect.permalink}${hash}`;
};

export default handleRedirect;
